module.exports = ".Root{min-width:400px;min-height:100%}\n"